<template>
	<div style="">


		<!-- lista produkt-typer -->
		<div id="productTypeList" class="flexcenter" style="">
			<div v-for="productType in this.productTypeModel?.list" :key="productType.key" class="link productType"
				:class="this.productTypeModel?.selected?.key == productType.key ? 'selected' : 'not-selected' "
				style="margin-bottom:0px;padding:5px;border-radius:5px;" @click.stop="this.setProductType(productType);">


				<b class="desktop font-small" style="flex-grow:1;">{{ productType.name }}</b>
				<b class="mobile font-smaller" style="flex-grow:1;">{{ productType.name }}</b>
			</div>
			<div v-if="this.debug">
				<Icon fileName="w3_button_close_light" style="width:20px;height:20px;" @click="this.setProductTypeNull()" />
			</div>
		</div>



	</div>
</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

import { routerMixin } from "@/mixins/routerMixin.js";
import { productSearchMixin } from "@/mixins/productSearchMixin.js";
import { STORE_COMMIT, STORE_GETTER } from "../store/store";
import { PRODUCT_STORE_GETTER } from "../store/product-store";

export default {
	name: "StartProductTypeButtonList",
	components: {},
	mixins: [routerMixin, productSearchMixin],
	props: {
		showProductType: Boolean
	},
	data() {
		return {
			
		};
	},
	computed: {

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		},

		productTypeModel() {
			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_MODEL];
		},

		productListLoading(){
			return this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST_LOADING];

		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });

		setProductType(productType) {
			//this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)
			//this.routerShowProductList()

			const name = this.$route.name;

			this.resetSearchProductConfig();

			this.$emit("closeProductType");

			if (name == "Products"){
				//alert(name);
				this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, productType)
				this.$router.replace("/" + productType.urlKey + "/products");
			}else{
				//alert(name);
				this.$router.push("/" + productType.urlKey + "/products");
				
			}

			this.$emit("closeProductType");
			
		},
		setProductTypeNull(){
			this.$store.commit(STORE_COMMIT.SELECT_PRODUCT_TYPE, null)
			this.$emit("closeProductType");
		},
		toggleProductType(){

			if (this.showProductType){
				this.$emit("closeProductType");
			}else{
				this.$emit("showProductType");
			}
		}


	},
	created() {

	}
};
</script>

<style scoped>
div#productTypeList {
	gap:5px;
}


div#productTypeList div.productType b{
	padding-left:5px;
	padding-right:5px;
}

div#productTypeList div.productType.not-selected{
	background: transparent;
	color: var(--font-color);
	padding-left:10px;
	padding-right: 20px;
}

@media (max-width: 768px) {
	
	div#productTypeList {
		gap: 0px;
	}

	div#productTypeList div.productType b {
		padding-left: 0px;
		padding-right: 0px;
	}

		div#productTypeList {
			gap: 0px;
		}

}

div#productTypeList div.productType.selected {
	background: var(--bg-message);
	color: white;
}
</style>